import { createTheme } from '@ant-design/cssinjs';
import defaultDerivative from './index';
const defaultTheme = createTheme(defaultDerivative);
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/themes/default/theme.js
// module id = 628
// module chunks = 0